import { createSlice } from "@reduxjs/toolkit";

const patientDrawerSlice = createSlice({
  name: "patientDrawer",
  initialState: {
    isOpen: false,
    patientId: null,
  },
  reducers: {
    openPatientDrawer(state, action) {
      state.isOpen = true;
      state.patientId = action.payload;
    },
    closePatientDrawer(state) {
      state.isOpen = false;
      state.patientId = null;
    },
  },
});

export const { openPatientDrawer, closePatientDrawer } = patientDrawerSlice.actions;
export default patientDrawerSlice.reducer;
